import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useNavigate } from "react-router-dom";
import { BASEURL } from "../../constants";
import 'react-tabulator/lib/styles.css';
import 'react-tabulator/lib/css/tabulator.min.css';
import '../Global/Styles/tabulatorStyles.css';
import { ReactTabulator } from 'react-tabulator';

import toast from "react-hot-toast";

function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}

const Users = () => {


    const { schoolId } = useParams();
    const navigate = useNavigate();
    const [creatorsData, setCreatorsData] = useState([]);
    const [studentsData, setStudentsData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const debouncedSearchTerm = useDebounce(searchTerm, 500);
    const [openPopup, setOpenPopup] = useState(null);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [teacherToDelete, setTeacherToDelete] = useState(null);
    const [rowData, setRowData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const notify = () => toast.success("User profile successfully created !!");
    const [file, setFile] = useState(null);
    const [selectedRole, setSelectedRole] = useState("creators"); // Default to "creators"
    const [columns, setColumns] = useState([]);
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({
        // Initial form state
        firstName: "",
        lastName: "",
        email: "",
        role: ""

    });

    // Fetch teachers data for the specific school
    useEffect(() => {
        const fetchData = async () => {
            try {
                let response;
                if (selectedRole === "creators") {
                    response = await axios.get(`${BASEURL}/api/fetch-creators/${schoolId}`);
                    setCreatorsData(response.data.creatorsData);
                    setFilteredData(response.data.creatorsData);
                } else if (selectedRole === "students") {
                    response = await axios.get(`${BASEURL}/api/fetch-students/${schoolId}`);
                    setStudentsData(response.data.studentsData);
                    setFilteredData(response.data.studentsData);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                toast.error("Failed to fetch data");
            }
        };

        fetchData();
    }, [selectedRole, schoolId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    // const handleNavigation = (event) => {

    //     if (selectedRole) {
    //         navigate(selectedRole);
    //     }
    // }


    console.log(formData, "formData")
    // Filter teachers data based on the search term
    // useEffect(() => {
    //     if (creatorsData) {
    //         const lowercasedSearchTerm = debouncedSearchTerm.toLowerCase();
    //         const filtered = creatorsData.filter(
    //             teacher =>
    //                 teacher.first_name.toLowerCase().includes(lowercasedSearchTerm) ||
    //                 teacher.last_name.toLowerCase().includes(lowercasedSearchTerm)
    //         );
    //         setFilteredTeachers(filtered);
    //     }
    // }, [debouncedSearchTerm, creatorsData]);


    useEffect(() => {
        if (selectedRole === "creators") {
            setColumns([
                { title: "Sno.", field: "number", width: 70, hozAlign: "center", cssClass: "center-text", headerSort: true, resizable: true },
                { title: "Name", field: "name", headerSort: true, resizable: true },
                { title: "Email", field: "email", headerSort: true, resizable: true },
                { title: "Contact", field: "contact", headerSort: true, resizable: true },
                { title: "Location", field: "location", headerSort: true, resizable: true },
                { title: "SAP ID", field: "sapId", headerSort: true, resizable: true },
                {
                    title: "Actions",
                    formatter: () => {
                        return '<button className="action-btn">•••</button>';
                    },
                    width: 100,
                    cellClick: (e, cell) => {
                        const rect = e.target.getBoundingClientRect();
                        setPopupPosition({ top: rect.top + window.scrollY, left: rect.left + window.scrollX - 280 });
                        setRowData(cell.getRow().getData());
                        setOpenPopup(cell.getRow().getData().id);
                    },
                    headerSort: false,
                },
            ]);
        } else if (selectedRole === "students") {
            setColumns([
                { title: "Sno.", field: "number", width: 70, hozAlign: "center", cssClass: "center-text", headerSort: true, resizable: true },
                { title: "Name", field: "name", headerSort: true, resizable: true },
                { title: "Email", field: "email", headerSort: true, resizable: true },
                { title: "Contact", field: "contact", headerSort: true, resizable: true },
                { title: "Location", field: "location", headerSort: true, resizable: true },
                { title: "SAP ID", field: "sapId", headerSort: true, resizable: true },
                { title: "Assigned Mentor", field: "mentor", headerSort: true, resizable: true },
                {
                    title: "Actions",
                    formatter: () => {
                        return '<button className="action-btn">•••</button>';
                    },
                    width: 100,
                    cellClick: (e, cell) => {
                        const rect = e.target.getBoundingClientRect();
                        setPopupPosition({ top: rect.top + window.scrollY, left: rect.left + window.scrollX - 280 });
                        setRowData(cell.getRow().getData());
                        setOpenPopup(cell.getRow().getData().id);
                    },
                    headerSort: false,
                },
            ]);
        }
    }, [selectedRole]);

    // Define columns for the Tabulator table
    // const columns = [
    //     { title: "Sno.", field: "number", width: 70, hozAlign: "center", cssClass: "center-text", headerSort: true, resizable: true },
    //     { title: "Name", field: "name", headerSort: true, resizable: true },
    //     { title: "Email", field: "email", headerSort: true, resizable: true },
    //     { title: "Contact", field: "contact", headerSort: true, resizable: true },
    //     { title: "Location", field: "location", headerSort: true, resizable: true },
    //     { title: "SAP ID", field: "sapId", headerSort: true, resizable: true },
    //     {
    //         title: 'Actions',
    //         formatter: () => {
    //             return '<button className="action-btn">•••</button>';
    //         },
    //         width: 100,
    //         cellClick: (e, cell) => {
    //             const rect = e.target.getBoundingClientRect();
    //             setPopupPosition({ top: rect.top + window.scrollY, left: rect.left + window.scrollX - 280 }); // Adjusted position to the left
    //             setRowData(cell.getRow().getData());
    //             setOpenPopup(cell.getRow().getData().id); // Set the row ID to identify the open popup
    //         },
    //         headerSort: false
    //     }
    // ];

    // Prepare table data for the ReactTabulator component
    // const data = (filteredTeachers || []).map((teacher, index) => ({
    //     id: teacher.id,
    //     number: index + 1,
    //     name: `${teacher.first_name} ${teacher.last_name}`,
    //     email: teacher.email,
    //     contact: teacher.contact_number,
    //     location: `${teacher.city}, ${teacher.state}`,
    //     sapId: teacher.sap_id,
    // }));

    useEffect(() => {
        if (selectedRole === "creators") {
            const creatorData = (filteredData || []).map((creator, index) => ({
                id: creator.id,
                number: index + 1,
                name: `${creator.first_name} ${creator.last_name}`,
                email: creator.email,
                contact: creator.contact_number,
                location: `${creator.city}, ${creator.state}`,
                sapId: creator.sap_id,
            }));
            setData(creatorData);
        } else if (selectedRole === "students") {
            const studentData = (filteredData || []).map((student, index) => ({
                id: student.id,
                number: index + 1,
                name: `${student.first_name} ${student.last_name}`,
                email: student.email,
                contact: student.contact_number,
                location: `${student.city}, ${student.state}`,
                sapId: student.sap_id,
                mentor: `${student.mentor_first_name} ${student.mentor_last_name}`,
            }));
            setData(studentData);
        }
    }, [filteredData, selectedRole]);


    useEffect(() => {
        if (selectedRole === "creators") {
            const lowercasedSearchTerm = debouncedSearchTerm.toLowerCase();
            const filtered = creatorsData.filter(
                (creator) =>
                    creator.first_name.toLowerCase().includes(lowercasedSearchTerm) ||
                    creator.last_name.toLowerCase().includes(lowercasedSearchTerm)
            );
            setFilteredData(filtered);
        } else if (selectedRole === "students") {
            const lowercasedSearchTerm = debouncedSearchTerm.toLowerCase();
            const filtered = studentsData.filter(
                (student) =>
                    student.first_name.toLowerCase().includes(lowercasedSearchTerm) ||
                    student.last_name.toLowerCase().includes(lowercasedSearchTerm)
            );
            setFilteredData(filtered);
        }
    }, [debouncedSearchTerm, creatorsData, studentsData, selectedRole]);

    // Navigate to the teacher's profile page
    const onViewDetails = (rowData) => {
        const { id } = rowData;
        navigate(`/admin/allCreators/${schoolId}/${id}`);

        setOpenPopup(null);
    };
    // useEffect(() => {
    //     const handleClickOutside = (event) => {
    //         if (openPopup && !event.target.closest(".popup")) {
    //             setOpenPopup(null);
    //         }
    //     };

    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => {
    //         document.removeEventListener("mousedown", handleClickOutside);
    //     };
    // }, [openPopup]);

    // Navigate to the edit teacher page
    const onEditTeacher = (rowData) => {
        const { id } = rowData;

        navigate(`/admin/editCreatorProfile/${schoolId}/${id}`);
        setOpenPopup(null);
    };

    // Show the delete confirmation dialog
    const onDeleteWithConfirmation = (rowData) => {
        const { id } = rowData;
        setTeacherToDelete(id);

        setShowDeleteConfirmation(true);
    };

    // Delete a teacher from the server
    const onDeleteTeacher = async () => {
        try {
            await axios.delete(`${BASEURL}/api/delete-creator`, {
                data: { schoolId, userId: teacherToDelete },
            });

            setShowDeleteConfirmation(false);
            toast.success("Creator Profile deleted successfully!");

            // Refetch data to update the table
            const fetchData = async () => {
                try {
                    let response;
                    if (selectedRole === "creators") {
                        response = await axios.get(`${BASEURL}/api/fetch-creators/${schoolId}`);
                        setCreatorsData(response.data.creatorsData);
                        setFilteredData(response.data.creatorsData);
                    } else if (selectedRole === "students") {
                        response = await axios.get(`${BASEURL}/api/fetch-students/${schoolId}`);
                        setStudentsData(response.data.studentsData);
                        setFilteredData(response.data.studentsData);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                    toast.error("Failed to fetch data");
                }
            };

            fetchData(); // Refetch data
            setOpenPopup(null); // Close the popup
        } catch (error) {
            console.error("Error deleting creator:", error);
            toast.error("Error deleting creator");
        }
    };

    // Cancel the delete operation
    const cancelDelete = () => {
        setTeacherToDelete(null);
        setShowDeleteConfirmation(false);
    };

    const options = {
        pagination: 'remote', // or 'local'
        paginationSize: 10, // number of rows per page
    };
    const handleSubmit = async (e) => {


        const requiredFields = ["firstName", "lastName", "email", "role"];
        for (const field of requiredFields) {
            if (!formData[field]) {
                toast.error(`${field.charAt(0).toUpperCase() + field.slice(1)}: Field is required`);
                return;
            }
        }

        const newFormData = new FormData();
        const data = { ...formData, schoolId };
        newFormData.append("userdata", JSON.stringify(data));
        newFormData.append("image", file);

        try {
            const response = await axios.post(`${BASEURL}/api/add-user/${schoolId}`, newFormData, {
                headers: { "Content-Type": "multipart/form-data" },
            });

            if (response.data.message === "email and role combination already used") {
                return toast.error("Email and role combination already used");
            }

            notify(); // Show success toast
            setShowModal(false); // Close the modal

            // Refetch data to update the table
            const fetchData = async () => {
                try {
                    let response;
                    if (selectedRole === "creators") {
                        response = await axios.get(`${BASEURL}/api/fetch-creators/${schoolId}`);
                        setCreatorsData(response.data.creatorsData);
                        setFilteredData(response.data.creatorsData);
                    } else if (selectedRole === "students") {
                        response = await axios.get(`${BASEURL}/api/fetch-students/${schoolId}`);
                        setStudentsData(response.data.studentsData);
                        setFilteredData(response.data.studentsData);
                    }
                } catch (error) {
                    console.error("Error fetching data:", error);
                    toast.error("Failed to fetch data");
                }
            };

            fetchData(); // Refetch data
        } catch (error) {
            console.error("Error adding user profile:", error);
            toast.error("Error adding user profile");
        }
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Ensure openPopup is not null
            if (openPopup && event.target.closest(".popup") === null) {
                setOpenPopup(null);
            }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openPopup]);
    

    return (
        <>
            {
                showModal &&
                // <div className="relative  z-30" aria-labelledby="modal-title" role="dialog" aria-modal="true">

                //     <div className="fixed  inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

                //     <div className="fixed h-full  inset-0 z-10 w-screen overflow-y-auto">
                //         <div className="flex min-h-full h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">

                //             <div style={{ minWidth: '20%' }} className="relative p-3 h-auto transform flex-col justify-evenly rounded-lg bg-white text-left shadow-xl transition-all my-8">
                //                 <div class="border-b border-gray-900/10 pb-12">
                //                     <h2 class="text-md font-semibold leading-7 text-gray-900 mt-4  pl-2 my-2 border-l-4 font-sans border-blue-400">Personal Information</h2>
                //                     <div class="mt-6 grid grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-6">
                //                         <div class="sm:col-span-3 sm:col-start-1">
                //                             <label for="first-name" class="block text-sm font-medium leading-6 text-gray-900">First Name <span className="text-red-600">*</span></label>
                //                             <div class="mt-2">
                //                                 <input type="text" name="firstName" placeholder="Enter your first name" value={formData.firstName} onChange={handleChange} required autocomplete="given-name" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6" />
                //                             </div>
                //                         </div>


                //                         <div class="sm:col-span-3">
                //                             <label for="last-name" class="block text-sm font-medium leading-6 text-gray-900">Last Name <span className="text-red-600">*</span></label>
                //                             <div class="mt-2">
                //                                 <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} required autocomplete="family-name" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6" placeholder="Enter your last name" />
                //                             </div>
                //                         </div>



                //                     </div>
                //                     <div class="mt-6 grid grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-6">
                //                         <div class="sm:col-span-3">
                //                             <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address</label>
                //                             <div class="mt-2">
                //                                 <input name="email" type="email" value={formData.email} onChange={handleChange} required autocomplete="email" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6" placeholder="Enter your email address" />
                //                             </div>
                //                         </div>
                //                         <div class="sm:col-span-3">
                //                             <label for="role" class="block text-sm font-medium leading-6 text-gray-900">Role</label>
                //                             <div class="mt-2">
                //                                 <input name="role" type="role" value={formData.role} onChange={handleChange} required autocomplete="role" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6" placeholder="Enter your role" />
                //                             </div>
                //                         </div>
                //                     </div>
                //                 </div>

                //             </div>
                //         </div>
                //     </div>
                // </div>

                <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-75">

                    <div class="bg-white p-6 rounded-lg w-full max-w-md sm:max-w-lg">

                        <div class="text-xl font-semibold mb-4">User Profile</div>


                        <div class="flex flex-col sm:flex-row sm:space-x-4 mb-4">

                            <div class="flex-1 mb-4 sm:mb-0">
                                <label for="first-name" class="block text-sm font-medium leading-6 text-gray-900">First Name <span className="text-red-600">*</span></label>
                                <div class="mt-2">
                                    <input type="text" name="firstName" placeholder="Enter your first name" value={formData.firstName} onChange={handleChange} required autocomplete="given-name" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6" />
                                </div>
                            </div>


                            <div class="flex-1">
                                <label for="last-name" class="block text-sm font-medium leading-6 text-gray-900">Last Name <span className="text-red-600">*</span></label>
                                <div class="mt-2">
                                    <input type="text" name="lastName" placeholder="Enter your last name" value={formData.lastName} onChange={handleChange} required autocomplete="given-name" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6" />
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col sm:flex-row sm:space-x-4 mb-4">

                            <div class="flex-1 mb-4 sm:mb-0">
                                <label for="email" class="block text-sm font-medium leading-6 text-gray-900">Email address <span className="text-red-600">*</span></label>
                                <div class="mt-2">
                                    <input name="email" type="email" value={formData.email} onChange={handleChange} required autocomplete="email" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6" placeholder="Enter your email address" />
                                </div>
                            </div>


                            <div class="flex-1">
                                <label for="role" class="block text-sm font-medium leading-6 text-gray-900">Role <span className="text-red-600">*</span></label>
                                <div class="mt-2">
                                    <div class="mt-2">
                                        <select name="role" value={formData.role} onChange={handleChange} required class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300  focus:ring-inset focus:border-blue-400 dark:focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring-2 focus:ring-opacity-40 px-4 sm:text-sm sm:leading-6 ">
                                            <option value="" disabled selected>
                                                Select Role
                                            </option>
                                            <option value='Creator'>Creator</option>
                                            <option value='Learner'>Learner</option>
                                            <option value='Mentor'>Mentor</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </div>


                        <div class="flex justify-end space-x-4">
                            <button class="px-4 py-2 bg-gray-200 rounded-md" onClick={() => setShowModal(false)}>Cancel</button>
                            <button class="px-4 py-2 bg-blue-500 text-white rounded-md" onClick={() => handleSubmit()} >Save</button>
                        </div>
                    </div>
                </div>

            }
            <div className='mx-4 border-b border-gray-200'>
                <div className='pt-2 pb-3 flex justify-between'>
                    <div className="flex items-center bg-white rounded-lg">
                        <select
                            className="peer w-full outline-none text-sm text-gray-700 pr-2 cursor-pointer"
                            onChange={(e) => setSelectedRole(e.target.value)}
                        >
                            <option value="creators">Creators</option>
                            <option value="students">Students</option>
                        </select>
                    </div>
                    <div className='flex flex-row justify-between flex-x-2'>
                        <div className="relative flex items-center rounded-lg focus-within:shadow-lg bg-white overflow-hidden mr-4">
                            <div className="grid place-items-center w-12 text-gray-300">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                </svg>
                            </div>
                            <input
                                className="peer w-full outline-none text-sm text-gray-700 pr-2"
                                type="text"
                                id="search"
                                placeholder="Search Creator Name"
                                onChange={(e) => setSearchTerm(e.target.value)} />
                        </div>
                        {/* <Link to={`/admin/addCreator/${schoolId}`}> */}
                        <button type="button" className="inline-flex mr-2 truncate justify-center items-center rounded-md bg-blue-500 px-3 py-2 text-xs font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 " >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 mx-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                            <span className='text-sm' onClick={() => setShowModal(true)}
                            >Add User</span>
                        </button>

                        <button type="button" className="inline-flex truncate justify-center items-center rounded-md bg-blue-500 px-3 py-2 text-xs font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 " >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 mx-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                            <span className='text-sm' onClick={() => setShowModal(true)}
                            >Bulk Import</span>
                        </button>
                        {/* </Link> */}
                    </div>
                </div>
            </div>
            {data.length > 0 ? (
                <ReactTabulator
                    data={data}
                    columns={columns}
                    layout="fitColumns"
                    responsiveLayout="hide"
                    tooltips={true}
                    options={options}
                    className="custom-tabulator-styles"
                />
            ) : (
                <div className="col-span-full w-full my-5 mx-auto">
                    <div className="flex justify-center my-0 mx-auto w-full">
                        <div className="flex flex-col items-center text-center max-w-sm">
                            <p className="p-3 text-sm font-medium text-blue-500 rounded-full bg-blue-50 dark:bg-gray-800">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="w-6 h-6 flex justify-center">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
                                </svg>
                            </p>
                            <p className="text-xl font-bold mt-2 text-gray-700">Oops! No creators found.</p>
                            <p className="mt-2">It looks like there are no creators here. Why not create one and get started?</p>
                        </div>
                    </div>
                </div>
            )}
            {openPopup && (
                <div 
                    className="absolute bg-white shadow-lg rounded-lg py-2 w-48 popup"
                    style={{ top: popupPosition.top, left: popupPosition.left }}
                >
                    <div className="cursor-pointer flex items-center px-3 py-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white" onClick={() => onViewDetails(rowData)}>
                        <svg className="w-5 h-5 mx-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8C17 10.7614 14.7614 13 12 13C9.23858 13 7 10.7614 7 8ZM12 11C13.6569 11 15 9.65685 15 8C15 6.34315 13.6569 5 12 5C10.3431 5 9 6.34315 9 8C9 9.65685 10.3431 11 12 11Z" fill="currentColor"></path>
                            <path d="M6.34315 16.3431C4.84285 17.8434 4 19.8783 4 22H6C6 20.4087 6.63214 18.8826 7.75736 17.7574C8.88258 16.6321 10.4087 16 12 16C13.5913 16 15.1174 16.6321 16.2426 17.7574C17.3679 18.8826 18 20.4087 18 22H20C20 19.8783 19.1571 17.8434 17.6569 16.3431C16.1566 14.8429 14.1217 14 12 14C9.87827 14 7.84344 14.8429 6.34315 16.3431Z" fill="currentColor"></path>
                        </svg>
                        <span className="mx-1">view profile</span>
                    </div>
                    <div className="cursor-pointer flex items-center p-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white" onClick={() => onEditTeacher(rowData)}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-5 h-5 mx-1">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                        </svg>
                        <span className="mx-1">Edit Profile</span>
                    </div>
                    <div className="cursor-pointer flex items-center p-3 text-sm text-gray-600 capitalize transition-colors duration-300 transform dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white" onClick={() => onDeleteWithConfirmation(rowData)}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mx-1">
                            <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.77 5.79m14.457-.165a48.108 48.108 0 0 1-14.91 0m14.91 0A2.252 2.252 0 0 0 17.25 4.5h-2.672a2.25 2.25 0 0 0-2.133-1.5h-3.89a2.25 2.25 0 0 0-2.134 1.5H6.75a2.252 2.252 0 0 0-2.228 2.125" />
                        </svg>
                        <span className="mx-1">Delete Creator</span>
                    </div>
                </div>
            )}
            {showDeleteConfirmation && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-15 backdrop-blur-sm transition-opacity duration-300 ease-out bg-gray-400">
                    <div className="relative inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl rtl:text-right dark:bg-gray-900 sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
                        <div>
                            <div className="flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-gray-700 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
                                </svg>
                            </div>
                            <div className="mt-2 text-center">
                                <h3 className="text-lg font-medium leading-6 text-gray-800 capitalize dark:text-white" id="modal-title">Confirm Delete</h3>
                                <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                                    Are you sure you want to delete this creator?
                                </p>
                            </div>
                        </div>
                        <div className="mt-5 sm:flex sm:items-center sm:justify-end">
                            <div className="sm:flex sm:items-center">
                                <button
                                    className="w-full px-4 py-2 mt-2 text-sm font-medium tracking-wide text-gray-700 capitalize transition-colors duration-300 transform border border-gray-200 rounded-md sm:mt-0 sm:w-auto sm:mx-2 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800 hover:bg-gray-100 focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-40"
                                    onClick={cancelDelete}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="w-full px-4 py-2 mt-2 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-red-600 rounded-md sm:w-auto sm:mt-0 hover:bg-red-500 focus:outline-none focus:ring focus:ring-red-300 focus:ring-opacity-40"
                                    onClick={onDeleteTeacher}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );


}

export default Users;